/// <amd-module name="Wit/WitFirstRun/Components/WitFirstRunComponent" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { ITeachingSlideProps, TeachingPanel } from "VSSUI/TeachingPanel";

import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";

export interface IWitFirstRunComponentProps {
    onDismiss: () => void;
    slides: ITeachingSlideProps[];
    settingName: string;
    className: string;
}

interface IDictionaryStringTo<T> {
    [key: string]: T;
}

export class WitFirstRunComponent extends VssComponent<IWitFirstRunComponentProps, {}> {
    public render(): JSX.Element | null {
        return <TeachingPanel slides={this.props.slides} className={this.props.className} onDismiss={this._onPanelClose} />;
    }

    private _onPanelClose = (index: number) => {
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("WebPlatform", "WitBoardsExperience", { action: "teachingPanelClosed", slideIndexProgressed: index });

        const settingEntries: IDictionaryStringTo<any> = {};
        settingEntries[this.props.settingName] = true;
        const settingsService = this.context.pageContext.getService<ISettingsService>("ISettingsService");
        this.props.onDismiss();
        settingsService.setEntries(settingEntries, SettingsUserScope.Me);
    };
}
